import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";
import api from "../../api";
import styles from "./login.module.css";
import Logo from '../../assets/logo.png';





export default function Login() {
    const [codope, setCodope] = useState("");
    const [senha, setSenha] = useState("");
    const [loading, setLoading] = useState(false);

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

  


    const handleLogin = async (e) => {
        e.preventDefault();
        if (!codope || !senha) return;

        try {
            setLoading(true);

            const response = await api.get(`/portal/login/?codfun=${codope}&senfun=${senha}`);


            const data = response.data;

            // 🔎 Validação baseada no seu retorno real
            if (!data || !data.codope) {
                alert("Usuário ou senha inválidos");
                return;
            }

            // 🔐 Salva todos os dados do colaborador
            login({
                codope: data.codope,
                nomope: data.nomope
            });


            navigate("/home");

        } catch (error) {
            alert("Erro ao conectar com servidor : " + error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.container}>



            <div className={styles.header}>
                <img src={Logo} alt="Logo" className={styles.logo} />
            </div>

            <div className={styles.content}>
                <div className={styles.card}>
                    <h2>Portal Cozimax</h2>
                    <p className={styles.subtitle}>Acesso</p>

                    <form onSubmit={handleLogin}>
                        <div className={styles.inputGroup}>
                            <input
                                type="text"
                                placeholder="Digite seu usuário"
                                value={codope}
                                onChange={(e) => setCodope(e.target.value)}
                            />
                        </div>

                        <div className={styles.inputGroup}>
                            <input
                                type="password"
                                placeholder="Digite sua senha"
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                            />
                        </div>

                        <button className={styles.button} type="submit" disabled={loading}>
                            {loading ? "Iniciando..." : "Acessar"}
                        </button>
                    </form>

                    <span className={styles.version}>Versão 1.0.0</span>


                </div>
            </div>
        </div>
    );
}